module.exports = __webpack_public_path__ + "static/media/logo-100oc.55bcd8df.svg";